import type { RumEvent } from "@datadog/browser-rum";
import { toPathOnlyUrl } from "./to-path-only-url";

type ViewFields = { url?: unknown; referrer?: unknown };
type ErrorResourceFields = { resource?: { url?: unknown } };

/**
 * Strip search/hash from every URL field on a RUM event that can carry the
 * host's query string (view, referrer, resource, error.resource).
 */
export function sanitizeRumEventUrls(event: RumEvent): void {
  const view = (event as { view?: ViewFields }).view;
  if (view) {
    if (typeof view.url === "string") {
      view.url = toPathOnlyUrl(view.url);
    }
    if (typeof view.referrer === "string") {
      view.referrer = toPathOnlyUrl(view.referrer);
    }
  }

  if (
    event.type === "resource" &&
    typeof event.resource?.url === "string"
  ) {
    event.resource.url = toPathOnlyUrl(event.resource.url);
  }

  const errorResourceUrl = (event as { error?: ErrorResourceFields }).error
    ?.resource?.url;
  if (typeof errorResourceUrl === "string") {
    (event as { error: { resource: { url: string } } }).error.resource.url =
      toPathOnlyUrl(errorResourceUrl);
  }
}

/** application.beforeSend hook — transform-only; never drops events. */
export function datadogRumBeforeSend(event: RumEvent): boolean | void {
  sanitizeRumEventUrls(event);
}
